<template>
    <div
        :class="$style['sorting-component']"
        v-show="mobile || moved || placeholderExists != null"
        data-sorting-component
    >
        <input
            type="hidden"
            :name="sortingOptionName"
            :value="value"
            form="productListFilterForm"
            ref="hiddenValue"
        />
        <div v-if="!mobile">
            <span :class="$style['sort-header']">{{
                labels.frontendProductList.filters.sorting.sortHeader
            }}</span>
            <!--<span :class="$style['current-sorting']" @click="openMenu = true">{{currentOptionText}}</span>-->
            <div :class="$style['sorting-checkbox-list']">
                <div
                    v-for="option in options"
                    :class="[
                        $style['sorting-checkbox-list-item'],
                        currentOption === option ? $style['active'] : '',
                    ]"
                >
                    <!--<div :class="$style['sorting-item-spacer']" v-if="options.indexOf(option) > 0"></div>-->
                    <label>
                        <cool-radio>
                            <input
                                type="radio"
                                :checked="currentOption === option"
                                @change="selectOption(option)"
                            />
                        </cool-radio>
                        {{ option.text }}
                    </label>
                </div>
            </div>
            <!--<div v-if="openMenu" :class="$style['sorting-menu']">
                <div :class="$style['blur-overlay']" @click="openMenu = false"></div>
                <template v-for="option in options">
                    <div :class="$style['sorting-item-spacer']" v-if="options.indexOf(option) > 0"></div>
                    <div>
                        <span :class="[$style['sorting-item'], currentOption === option ? $style['selected'] : '']" @click="selectOption(option)">{{option.text}}</span>
                    </div>
                </template>
            </div>-->
        </div>
        <div v-else>
            <div :class="$style['sorting-items']">
                <template v-for="option in options">
                    <div>
                        <span
                            :class="[
                                $style['sorting-item'],
                                currentOption === option
                                    ? $style['selected']
                                    : '',
                            ]"
                            @click="selectOption(option)"
                            >{{ option.text }}</span
                        >
                    </div>
                    <div :class="$style['sorting-item-spacer']"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<style module>
:global(.mobile) .sorting-items {
    display: block;
}

:global(.desktop) .sorting-component {
    white-space: nowrap;
}

:global(.desktop) .sort-header {
    color: #272727;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: bold;
}

.sort-header {
    font-weight: 600;
}

.sorting-component {
    position: relative;
    font-size: 14px;
}
.current-sorting {
    text-decoration: underline;
    cursor: pointer;
}

.sorting-item {
    cursor: pointer;
}

.sorting-checkbox-list {
    display: inline-block;
}
.sorting-checkbox-list-item {
    display: inline-block;
    margin-left: 8px;
    color: #272727;
    font-family: "Open Sans";
    font-size: 12px;
}

.sorting-checkbox-list-item.active {
    font-weight: bold;
}

:global(.mobile) .sorting-item.selected {
    font-weight: 600;
}

:global(.mobile) .sorting-item-spacer {
    background-color: #979797;
    margin-top: 15px;
    margin-bottom: 15px;
}

.sorting-item-spacer {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
    height: 1px;
    width: 100%;
}

.sorting-menu {
    position: absolute;
    padding: 15px;
    border: 2px solid #272727;
    border-radius: 2px;
    background-color: #ececec;
    z-index: 1;
    right: 0;
    top: 0;
}

.blur-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: -1;
}
</style>

<script setup lang="ts">
import {
    type PropType,
    computed,
    getCurrentInstance,
    nextTick,
    onMounted,
    ref,
    watch,
} from "vue";
import CoolRadio from "../../shared/CoolRadio.vue";
import labels from "../../shared/labels";
import { type SortingOptionItem } from "./types";

const props = defineProps({
    options: {
        type: Array as PropType<SortingOptionItem[]>,
        required: true,
    },
    sortingOptionName: String,
    value: String,
});

const mobile = ref(!document.body.classList.contains("desktop"));
const openMenu = ref(false);

const currentOption = computed(() => {
    return props.options.find((opt) => opt.value === props.value);
});
// const currentOptionText = computed(() => {
//     const currOption = currentOption.value;
//     if (currOption != null) return currOption.text;
//     return labels.frontendProductList.filters.sorting.sortValueEmpty;
// });

watch(
    () => props.value,
    () => {
        nextTick(function () {
            submitForm();
        });
    }
);
const emit = defineEmits(["input", "submitForm"]);
function emitValue(v: string) {
    //console.log("EMIT SORTING: "+value);
    emit("input", v);
}
function selectOption(option: SortingOptionItem) {
    emitValue(option.value);
    openMenu.value = false;
}

const hiddenValue = ref<HTMLInputElement>();

function submitForm() {
    emit("submitForm");
}

const option = props.options.find((x) => x.selected);
if (option != null) emitValue(option.value);

const instance = getCurrentInstance();

const placeholderElement = ref<HTMLElement | undefined | null>(undefined);
const placeholderExists = computed(() => {
    if (placeholderElement.value === undefined) return undefined;
    return placeholderElement.value != null;
});
const moved = ref(false);

function getPlaceholderElement() {
    return document.querySelector<HTMLElement>(".sorting-placeholder");
}

function checkForPlaceholderElement(source: string) {
    if (mobile.value) {
        console.debug(
            "sorting-placeholder: cancel: mobile. no placeholder needed"
        );
        return;
    }
    if (placeholderElement.value != null) {
        console.debug("sorting-placeholder: cancel: already have placeholder");
        return;
    }
    placeholderElement.value = getPlaceholderElement();
    console.debug(
        "sorting-placeholder: " +
            (placeholderElement.value ? "got placeholder" : "no placeholder") +
            " from " +
            source
    );
}

//checkForPlaceholderElement();

if (placeholderElement.value == null) {
    document.addEventListener("DOMContentLoaded", () => {
        checkForPlaceholderElement("DOMContentLoaded");
    });
}

function tryMoveToPlaceholder(container: HTMLElement) {
    console.debug("try move placeholder");
    if (instance?.proxy == null) return false;
    if (moved.value) return true;
    // const container = document.querySelector(".sorting-placeholder");
    if (container == null) return false;
    container.appendChild(instance.proxy.$el);
    moved.value = true;
    return true;
}

// watch(
//     () => mobile.value || placeholderExists.value == false || moved.value,
//     (newValue) => {
//         console.log("v-show", newValue, {
//             mobile: mobile.value,
//             placeholderExists: placeholderExists.value,
//             moved: moved.value,
//         });
//     },
//     {
//         immediate: true,
//     }
// );

onMounted(() => {
    if (!mobile.value) {
        checkForPlaceholderElement("onMounted");
        if (
            placeholderElement.value == null ||
            !tryMoveToPlaceholder(placeholderElement.value)
        ) {
            //console.warn("doc",document.readyState);
            // document.addEventListener("readystatechange", function (ev) {
            //     console.debug("doc", document.readyState);
            // });
            document.addEventListener("DOMContentLoaded", () => {
                if (placeholderElement.value)
                    tryMoveToPlaceholder(placeholderElement.value);
            });
        }
    }
});
</script>
